/**
 *  权限管理相关接口
 */
import { axios } from '@/utils/request'

// 查询权限树形结构数据
export function queryPermissionTree (parameter) {
  return axios({
    url: '/sys/permission/queryTree',
    method: 'get',
    params: parameter
  })
}

// 创建权限信息接口
export function savePermission (parameter) {
  return axios({
    url: '/sys/permission',
    method: 'post',
    data: parameter
  })
}

// 修改权限接口
export function updatePermission (id, parameter) {
  return axios({
    url: `/sys/permission/${id}`,
    method: 'put',
    data: parameter
  })
}

// 修改权限接口
export function deletePermission (parameter) {
  return axios({
    url: '/sys/permission',
    method: 'delete',
    params: parameter
  })
}

// 修改启用状态
export function changeEnabled (id, parameter) {
  return axios({
    url: `/sys/permission/${id}/changeEnabled`,
    method: 'patch',
    data: parameter
  })
}
